import Axios from '../../../axios';
import { Toast } from '../../../components/spinner';
import { encrypt } from '../../../redux/helper/cryptojs';
import { PrizeTrivia, Headers } from '../../../axios/axios_config';

export function saveBonusGame(gameData) {
    Axios.post(PrizeTrivia.savePrizeTriviaGame.url, { "Items": gameData.Items, "GenreType": gameData.GenreType }, Headers())
        .then(response => {
            const { data } = response;
            if (data?.Item) {
                window.location.href = `/Hitmaker/prize-trivia?mode=${encrypt("result")}&userGameId=${encrypt(data.Item)}&maxItem=${encrypt(gameData.maxItem)}&noOfCorrect=${encrypt(gameData.noOfCorrect)}`
            } else {
                Toast({ timer: 3000 }).fire({ text: "Something went wrong. Try again later!", position: 'bottom', })
                    .then(() => window.location.reload());
            }
        })
        .catch(err => {
            console.log('Unable to get bonus list.', err);
        });
};